(function () {
	let initializedSwipers = [];

	const toBoolean = (string) => {
		return string === true || string === "true";
	};

	const isSliderLayout = (slider) => {
		const layout = slider.dataset.layout || "slider";
		return layout === "slider" && !!slider.querySelector(".swiper");
	};

	const isMobileSliderEnabled = (slider) => {
		const value = slider.dataset.enableMobileSlider;
		if (value === undefined || value === null || value === "") return true;
		return toBoolean(value);
	};

	const productSlider = () => {
		const productSliders = Array.from(document.querySelectorAll(".products-slider"));
		if (productSliders.length === 0) return;

		productSliders.forEach((slider) => {
			if (!isSliderLayout(slider)) return;

			const onMobile = window.innerWidth < 768;
			if (onMobile && !isMobileSliderEnabled(slider)) return;
			if (slider.classList.contains("slider_started")) return;

			slider.classList.add("slider_started");

			const sectionId = slider.dataset.id;
			const perRow = Number(slider.dataset.perRow) || 4;
			const mobile = Number(slider.dataset.mobile) || 1;
			const speed = Number(slider.dataset.speed) * 1000 || 1100;
			const delay = Number(slider.dataset.delay) * 1000 || 3000;
			const autoplay = toBoolean(slider.dataset.autoplay);
			const stopAutoplay = toBoolean(slider.dataset.stopAutoplay);
			const showArrows = toBoolean(slider.dataset.showArrows);

			let autoplayParm = {};
			let arrowsParm = {};

			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			}

			arrowsParm = {
				pagination: {
					el: `#${sectionId} .swiper-pagination`,
					clickable: true,
				},
			};

			if (showArrows) {
				arrowsParm.navigation = {
					nextEl: `#${sectionId} .swiper-button-next`,
					prevEl: `#${sectionId} .swiper-button-prev`,
				};
			}

			const swiperEl = slider.querySelector(".swiper");
			if (!swiperEl) return;

			const swiperParms = {
				speed: speed,
				keyboard: true,
				slidesPerView: mobile,
				spaceBetween: 0,
				breakpoints: {
					576: {
						slidesPerView: perRow >= 2 ? 2 : 1,
					},
					750: {
						slidesPerView: perRow >= 3 ? 3 : perRow,
					},
					990: {
						slidesPerView: perRow >= 4 ? 4 : perRow,
					},
					1150: {
						slidesPerView: perRow,
					},
				},
				mousewheel: {
					forceToAxis: true,
				},
				...arrowsParm,
				...autoplayParm,
			};

			const swiper = new Swiper(swiperEl, swiperParms);
			initializedSwipers.push({ swiper, slider });
		});
	};

	const destroyAllSwipers = () => {
		initializedSwipers.forEach((entry) => {
			const swiper = entry.swiper || entry;
			if (swiper && swiper.destroy) {
				swiper.destroy(true, true);
			}
		});
		initializedSwipers = [];

		document.querySelectorAll(".products-slider.slider_started").forEach((slider) => {
			slider.classList.remove("slider_started");
		});
	};

	const destroyMobileDisabledSwipers = () => {
		initializedSwipers = initializedSwipers.filter((entry) => {
			const slider = entry.slider;
			const swiper = entry.swiper || entry;
			if (
				slider &&
				window.innerWidth < 768 &&
				isSliderLayout(slider) &&
				!isMobileSliderEnabled(slider)
			) {
				if (swiper && swiper.destroy) swiper.destroy(true, true);
				slider.classList.remove("slider_started");
				return false;
			}
			return true;
		});
	};

	const adjustButtonPosition = (height) => {
		document.querySelectorAll(`.products-slider .swiper-button`).forEach((button) => {
			button.style.top = height / 2 + 20 + "px";
		});
	};

	const changePosition = () => {
		if (window.innerWidth < 1150) return;

		const image = document.querySelector(`.products-slider .media img`);
		if (image) {
			if (image.tagName === "IMG") {
				if (image.complete) {
					adjustButtonPosition(image.offsetHeight);
				} else {
					image.addEventListener("load", function () {
						adjustButtonPosition(this.offsetHeight);
					});
				}
			} else if (image.tagName === "svg") {
				const height = image.getBoundingClientRect().height;
				adjustButtonPosition(height);
			}
		}
	};

	const updateMobileGridClass = () => {
		document.querySelectorAll(".products-slider").forEach((slider) => {
			const useGrid =
				window.innerWidth < 768 &&
				(!isSliderLayout(slider) || !isMobileSliderEnabled(slider));

			if (useGrid) {
				slider.classList.add("product-list--2-mobile-grid");
			} else {
				slider.classList.remove("product-list--2-mobile-grid");
			}
		});
	};

	if (document.querySelector("product-recommendations") !== null) {
		const initslider = setInterval(() => {
			const swiperContainer = document
				.querySelector("product-recommendations")
				.querySelector(".swiper");

			if (swiperContainer !== null) {
				if (swiperContainer.classList.contains("swiper-initialized")) {
					clearInterval(initslider);
				}
				productSlider();
			}
		}, 100);
	}

	document.addEventListener("DOMContentLoaded", function () {
		updateMobileGridClass();
		productSlider();
		changePosition();

		document.addEventListener("shopify:section:load", function () {
			destroyAllSwipers();
			updateMobileGridClass();
			productSlider();
			changePosition();
		});
	});

	let resizeTimeout;
	window.addEventListener("resize", function () {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			destroyMobileDisabledSwipers();
			updateMobileGridClass();
			changePosition();
			productSlider();
		}, 200);
	});
})();
